import { SimpleCallback, Modal, ModalCloseProps } from 'platform-components';
import { CloseButton } from 'platform-components/src/components/close-button/_view/close-button_view_outer';
import React from 'react';

import { CertificateModalQueryForm } from './__query-form/certificate-modal__query-form';
import { CertificateModalSuccessLetter } from './__success-letter/certificate-modal__success-letter';
import { EmailData, FullNameData, LocalityData, SchoolData, TextData, ImageData } from './typings';

import './certificate-modal.scss';

interface Props {
    handleClose: SimpleCallback;
    handleAcceptClick: SimpleCallback;
    handleCancel: SimpleCallback;

    hasAgreedToReceiveCertificate: boolean;
    canChangeData: boolean;
    isButtonDisabled: boolean;
    canCancelSuggestion: boolean;

    imageData: ImageData;
    textData: TextData;

    fullNameData: FullNameData;
    localityData: LocalityData;
    schoolData: SchoolData;
    emailData: EmailData;
}

export const CertificateModal = (props: Props) => {
    const { handleClose, emailData, hasAgreedToReceiveCertificate } = props;

    return (
        <Modal
            Close={(closeProps: ModalCloseProps) => (
                <CloseButton {...closeProps} position={CloseButton.POSITION.ABSOLUTE} />
            )}
            hasClose
            mix="certificate-modal"
            onRequestClose={handleClose}
            opened={true}
            theme={Modal.THEMES.TEACHER}
            useScale={false}
        >
            {hasAgreedToReceiveCertificate ? (
                <CertificateModalSuccessLetter email={emailData.email} onAccept={handleClose} />
            ) : (
                <CertificateModalQueryForm {...props} />
            )}
        </Modal>
    );
};
